import { hasIOSupport } from '../helpers/feature-detects';

function fireButtonVis(buttonVis) {
  const evt = new CustomEvent('button-change', { detail: { buttonVis } });
  // console.log('a button is', buttonVis ? 'visible' : 'not visible');
  document.dispatchEvent(evt);
}

let wasAButtonVisible = false;

function observeHeaders(container) {
  const shObserver = new IntersectionObserver(
    (records) => {
      const isButtonVis = records.filter((record) => record.isIntersecting)
        .length;
      if (!wasAButtonVisible && isButtonVis) {
        fireButtonVis(true);
        wasAButtonVisible = isButtonVis;
      } else if (wasAButtonVisible && !isButtonVis) {
        fireButtonVis(false);
        wasAButtonVisible = isButtonVis;
      }
    },
    {
      threshold: [0, 1],
      // root: container,
      // rootMargin: '76px 0 0 0',
    },
  );

  container
    .querySelectorAll('.topper, .no-sms-btn')
    .forEach((el) => shObserver.observe(el));
}

if (hasIOSupport) {
  observeHeaders(document.querySelector('body'));
}

document.addEventListener('button-change', (e) => {
  const { buttonVis } = e.detail;
  if (buttonVis) {
    document.documentElement.classList.remove('no-button-visible');
  } else {
    document.documentElement.classList.add('no-button-visible');
  }
});
